import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { BikeCard } from "../components/BikeCard";
import { Button } from "../components/ui/button";

const FILTERS = [
  { key: "all", label: "All bikes" },
  { key: "moped", label: "Scooters & Mopeds" },
];

export default function Browse() {
  const [bikes, setBikes] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = filter === "all" ? {} : { type: filter };
    api.get("/bikes", { params }).then((res) => setBikes(res.data)).finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
      <span className="label-caps text-primary">The fleet</span>
      <h1 className="mt-3 text-4xl sm:text-5xl font-black tracking-tighter">Browse bikes</h1>
      <p className="mt-3 text-muted-foreground text-lg max-w-xl">Weekly & monthly hire. CBT required · Provisional licence accepted · 18+ · Your own insurance.</p>

      <div className="mt-8 flex gap-3">
        {FILTERS.map((f) => (
          <Button
            key={f.key}
            data-testid={`filter-${f.key}`}
            variant={filter === f.key ? "default" : "outline"}
            onClick={() => setFilter(f.key)}
            className={filter === f.key ? "bg-primary hover:bg-[#1D4ED8] text-white font-bold" : "font-semibold hover:text-primary hover:border-primary"}
          >
            {f.label}
          </Button>
        ))}
      </div>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="bikes-grid">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => <div key={`skeleton-${i}`} className="h-80 rounded-xl bg-secondary animate-pulse" />)
          : bikes.map((b) => <BikeCard key={b.id} bike={b} />)}
      </div>
      {!loading && bikes.length === 0 && (
        <p className="text-muted-foreground mt-10">No bikes found.</p>
      )}
    </div>
  );
}
